import { useEffect, useState } from 'react';
import './Task.scss'
import Button from '../Button/Button';
import Modal from '../Modal/Modal';
import api from '../../js/api';

export default function Task({ taskData, listID = null, isOpen = false }) {

    const [open, setOpen] = useState(isOpen);
    const [task, setTask] = useState(taskData);
    const [now, setNow] = useState(null);

    useEffect(() => api.get('/now').then((data) => data && data.datetime && setNow(data.datetime)), []);

    async function complete(value = true) {
        console.log('Completing task:', task.id, 'to', value);
        api.put(`/user/lists/${listID}/tasks/${task.id}`, {
            is_completed: value
        }).then((data) => {
            console.log(data)
            if (data.error) {
                console.error('Error completing task:', data.error);
                return;
            }
            setTask({ ...task, is_completed: value });
        }).catch((err) => {
            console.error('Error completing task:', err);
        });
    }

    return (
        <div id="task">
            {task && <div>
                <div className='flex gap flex-center'>
                    <Button
                        text={task.is_completed ? '[✔]' : '[ ]'}
                        style_={{ minWidth: '60px' }}
                        onClick={() => complete(!task.is_completed)}
                    >
                    </Button>
                    <Button
                        style_={{ flexGrow: 1, textAlign: 'left' }}
                        onClick={() => setOpen(true)} class_="task-button"
                    >
                        <div className="task-title">{task.title}</div>
                        {task.description && <div className="task-description subtext">{task.description}</div>}
                    </Button>
                </div>
            </div>
            }
            {open &&
                <Modal
                    text={task.title}
                    callback={() => setOpen(false)}
                    isOpen={true}
                >
                    <div className="task-details">
                        {task.title ? <h2>{task.title + " - " + task.id}</h2> : "Task " + task.id}
                        {<br />}
                        {task.description && <p>{task.description}</p>}
                        {<br />}
                        {<p><b>Status</b>: {task.is_completed ? <span>Completed</span> : <span>Incomplete</span>}</p>}
                        {
                            <div className='flex gap flex-align-center'>
                                {<span><b>Priority</b>:  </span>}
                                {<Button text="-" style_={task.priority > 0 ? {} : { visibility: 'hidden' }} onClick={async () => {
                                    const data = await api.put(`/user/lists/${listID}/tasks/${task.id}`, { priority: task.priority - 1 });
                                    if (data.error) {
                                        console.error('Error updating priority:', data.error);
                                        return;
                                    }

                                    setTask({ ...task, priority: task.priority - 1 });
                                }} />}

                                {<span>{task.priority} </span>}

                                {<Button text="+" style_={task.priority < 10 ? {} : { visibility: 'hidden' }} onClick={async () => {
                                    const data = await api.put(`/user/lists/${listID}/tasks/${task.id}`, { priority: task.priority + 1 })
                                    if (data.error) {
                                        console.error('Error updating priority:', data.error);
                                        return;
                                    }
                                    setTask({ ...task, priority: task.priority + 1 });
                                }} />}
                            </div>
                        }
                        {task.created_at && (
                            <p>
                                <b>Created at</b>: {new Date(task.created_at).toISOString().split('T')[0]}
                            </p>
                        )}
                        {task.updated_at && (
                            <p className="margin-top">
                                <b>Last updated</b>: {new Date(task.updated_at).toISOString().split('T')[0]}
                            </p>
                        )}
                        {task.completed_at && (
                            <p>
                                <b>Completed at</b>: {new Date(task.completed_at).toISOString().split('T')[0]}
                            </p>
                        )}
                        {<br />}
                        {
                            <div className='flex gap flex-space-between'>
                                {task.is_completed && <Button text="Mark as Incomplete" onClick={() => complete(false)} />}
                                {!task.is_completed && <Button text="Mark as Completed" onClick={() => complete()} />}
                                <Modal text="Remember via Telegram">
                                    <h3>Send Reminder via Telegram</h3>
                                    <br />
                                    <input type="datetime-local" id="reminder-date" className='input' placeholder="YYYY-MM-DD HH:MM:SS" value={now} onChange={(e) => setNow(e.target.value)} />
                                    <br />
                                    <br />
                                    {<Button text="Send" onClick={async () => {
                                        console.log('now:', now.replace('T', ' '));
                                        const r = await api.post(`/user/send/telegram`, {
                                            text: `Reminder for task: ${task.title}\n\nDescription: ${task.description || 'No description'}\n\nStatus: ${task.is_completed ? 'Completed' : 'Incomplete'}`,
                                            chat_name: 'recordatorios',
                                            send_at: now.replace('T', ' '),
                                        });
                                        if (r.error) {
                                            console.error('Error sending telegram reminder:', r.error);
                                            return;
                                        }
                                        alert('Telegram reminder sent!');
                                    }} />}
                                </Modal>
                                {<Button class_="red white-text" onClick={async () => {
                                    if (!window.confirm('Are you sure you want to delete this task?')) {
                                        return;
                                    }
                                    const r = await api.delete(`/user/lists/${listID}/tasks/${task.id}`);
                                    if (r.error) {
                                        console.error('Error deleting task:', r.error);
                                        return;
                                    }
                                    setOpen(false);
                                    setTask(null);
                                }}>
                                    <span className='material-icon icon-button'>delete</span>
                                </Button>
                                }
                            </div>
                        }
                    </div>
                </Modal>
            }
        </div>
    );
}